import $http from "../axios";

const state = {
  orders: []
};

const getters = {
  orders: state => {
    return state.orders;
  },

  ordersReverse: state => {
    return JSON.parse(JSON.stringify(state.orders)).reverse();
  }
};

const actions = {
  getOrders({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          `orders?storeId=${data.storeId}&beginDate=${data.dates[0]}&endDate=${
            data.dates[1]
          }`
        )
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_ORDERS", res.data.payload);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  makeOrder({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`make-order`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("APPEND_ORDER", res.data.payload.order);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  getOrderDetails(_, orderId) {
    return new Promise((resolve, reject) => {
      $http
        .get(`order-details?orderId=${orderId}`)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_ORDERS(state, payload) {
    state.orders = payload.orders;
  },

  APPEND_ORDER(state, order) {
    state.orders.push(order);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
